import { createAction, props } from '@ngrx/store';
import type { LinkFieldValue } from '@core/jss-models';
import type { StoreProductData } from '@legacy/common-ui-models';

import type { BoilersAdviceFormData } from '../models/boilers-advice-form-data.interface';

const prefix = '[Eplus Boilers]';

export const selectBoilerProductAction = createAction(
  `${prefix} Select Boiler Product`,
  props<{ product: StoreProductData }>()
);

export const submitAdviceForm = createAction(
  `${prefix} Submit Advice Form`,
  props<{
    formData: BoilersAdviceFormData;
    onSuccessRedirectPage: LinkFieldValue;
  }>()
);

export const submitAdviceFormSuccess = createAction(
  `${prefix} Submit Advice Form Success`
);

export const submitAdviceFormError = createAction(
  `${prefix} Submit Advice Form Error`
);

export const resetBoilerState = createAction(`${prefix} Reset Boiler State`);
